var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjNutricion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.342 -0.342)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(0.342 0.342)",
    fill: "#394F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.14,390.309a5,5,0,0,1-.714-3.008c-.01-.834-.125-1.668-.219-2.5a.718.718,0,0,1,.282-.783.646.646,0,0,1,.8.049c.913.711,1.846,1.4,2.715,2.162a4.384,4.384,0,0,1,1.256,1.993l.125.086a1.478,1.478,0,0,1,.2-.338,4.181,4.181,0,0,1,2.918-1.223.854.854,0,0,1,.952.834.863.863,0,0,1-.9.891,2.623,2.623,0,0,0-2.522,3.092c.177-.093.339-.169.492-.26a5.82,5.82,0,0,1,2.934-.92,4.838,4.838,0,0,1,4.332,2.353,7.472,7.472,0,0,1,.957,5.536,9.334,9.334,0,0,1-3.683,6.184,5.4,5.4,0,0,1-4.834,1.047c-.315-.087-.607-.258-.916-.372a.456.456,0,0,0-.326-.013,4.836,4.836,0,0,1-4.616.025,8.378,8.378,0,0,1-4.189-4.54,9.719,9.719,0,0,1-.731-4.89,5.825,5.825,0,0,1,3.143-4.863A5.247,5.247,0,0,1,973.14,390.309Zm12.042,6.365c-.05-.384-.076-.838-.171-1.277a3.884,3.884,0,0,0-2.224-3.045,3.569,3.569,0,0,0-3.345.423,4.251,4.251,0,0,1-4.606.007,5.29,5.29,0,0,0-1.049-.48,3.1,3.1,0,0,0-3.447.857,4.734,4.734,0,0,0-1.135,2.53,7.378,7.378,0,0,0,.7,4.474,6.589,6.589,0,0,0,3.557,3.563,3,3,0,0,0,3.068-.388.872.872,0,0,1,1.208,0,2.94,2.94,0,0,0,1.381.6,3.926,3.926,0,0,0,3.011-.946A8.13,8.13,0,0,0,985.182,396.674Zm-11.428-10.653c0,.759-.027,1.474.006,2.186a2.89,2.89,0,0,0,2.085,2.534,3.184,3.184,0,0,0-.069-2.674A7.01,7.01,0,0,0,973.754,386.021Z",
    transform: "translate(-955.07 -373.48)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjNutricion);
export default __webpack_public_path__ + "static/media/OBJ-NUTRICION.342d18fbff00b80f1fb067c7ce367a3e.svg";
export { ForwardRef as ReactComponent };